import React from "react";
import './footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="flex justify-center items-center p-4 bg-gray-900 text-white text-center">
      <img src="/footer-logo.png" />
      <p>Global Management Inc, © 2025 All rights reserved</p>
    </footer>
  );
};

export default Footer;